import GameApp from "../../../index";

export class PathfinderHandler {
  static handle(data) {
    const scene = GameApp.game.currentScene as any;

    switch (data.action) {
      case "found-path":
        scene.emit("move-user", {
          id: data.message.user,
          path: data.message.path,
          endAction: data.message.endAction,
        });
        break;
    }
  }
}
